export default {
  meta: {
    title: '提交复盘'
  }
};
